import 'assets/css/HAGD-Custom.css';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useState} from 'react';
import DNS from 'components/DNS/dns.js';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {DateRange} from 'react-date-range';
import Moment from 'react-moment';
import 'assets/css/commentaireOverview.css';

// react-bootstrap components
import {
  Button,
  Card,
  Modal,
  Form,
  Table,
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import {fr} from 'react-date-range/dist/locale';

/**
 * This function handle all the event and style in the colis page.
 * @function Colis
 * @return {HTML} the colis's page.
 */
const Colis = () => {
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);

  const [showModal, setShowModal] = React.useState(false);
  const [showRecipient, setRecipient] = useState('');
  const [showHour, setHour] = useState('');
  const [showDate, setDate] = useState('');
  const [showSender, setSender] = useState('');
  const [showCompany, setCompany] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDisplayDateRange, setDisplayDateRange] = useState('none');
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [alist, setList] = useState({
    data: null,
    error: false,
  }, []);
  const requestOptions = {
    method: 'GET',
    headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
  };
  useEffect(() => {
    getParcel();
  }, []);

  const resetValues = () => {
    setSender('');
    setHour('');
    setDate('');
    setRecipient('');
    setCompany('');
  };

  const getParcel = () => {
    fetch(DNS + '/parcel/crudParcel/' + currentBuilding['currentbuildingRedux'].pk + '/', requestOptions)
        .then(async (response) => {
          const data = await response.json();
          if (data.fields) {
            // console.log(data.fields)
            setList({
              data: data.fields,
              error: false,
            });
            return;
          } else {
            setList({
              data: data.fields,
              error: false,
            });
            return;
          }
        });
  };

  const CreateParcel = () => {
    const requestOptions = {
      method: 'PUT',
      headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
      body: JSON.stringify({
        'parcelSender': showSender,
        'parcelStatus': 'en attente',
        'time': showHour,
        'date': showDate,
        'recipient': showRecipient,
        'companyName': showCompany,
      }),
    };
    fetch(DNS + '/parcel/crudParcel/' + currentBuilding['currentbuildingRedux'].pk + '/', requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.fields) {
          // console.log(data.fields)
            resetValues();
            setList({
              data: data.fields,
              error: false,
            });
          } else {
            console.log('FAILED REQUEST');
            return;
          }
        });
  };

  let content = null;

  if (alist.error) {
    content = <p>
    ERROR: couldn't load Parcel list properly.
    </p>;
  }

  if (alist.data) {
    content =
      alist.data.slice(0).reverse().filter((val) => {
        const CheckDate = new Date(val.date).setHours(0, 0, 0, 0);
        const DateStart = state[0].startDate.setHours(0, 0, 0, 0);
        const DateEnd = state[0].endDate.setHours(0, 0, 0, 0);
        if (DateStart <= CheckDate && CheckDate <= DateEnd) {
          if (searchTerm == '') {
            return val;
          } else if (val.recipient.toLowerCase().includes(searchTerm.toLowerCase())) {
            return val;
          }
        }
      }).map((Parcel, key) =>
        <tr id='pk' value={Parcel.pk} key={key}>
          <td>{Parcel.recipient}</td>
          <td>{Parcel.time}</td>
          <td><Moment format="DD/MM/YYYY">{Parcel.date}</Moment></td>
          <td>{Parcel.parcelSender}</td>
          <td>
            { Parcel.parcelStatus == 'reçu' ? <i style={{color: 'green'}} className="fa fa-check" /> :
              Parcel.parcelStatus == 'en attente' ? <i style={{color: 'blue'}} className="fas fa-minus" /> :
              <i style={{color: 'red'}} className="fas fa-times" />}
            { Parcel.parcelStatus == 'reçu' ? <a></a> :
              Parcel.parcelStatus == 'en attente' ? <a> Le Livreur monte</a> :
              <a> L'accueil garde le colis</a>}
          </td>
          <td>{Parcel.email == 'a@a.fake' ? null : Parcel.email}</td>
          <td>
            <br/>
            <div className="myDIV2">
              <p style={{bottom: '100px'}}>
                <i className="fas fa-comment"></i>
              </p>
            </div>
            <div className="hide">
              {Parcel.comment}
            </div>
          </td>
        </tr>,
      );
  }
  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card className="strpied-tabled-with-hover">
            <Card.Header>
              <Card.Title as="h4">Mes Plis et Colis</Card.Title>
              <p className="card-category">
                <br></br>
              </p>
              <div className="row" style={{paddingTop: '15px'}}>
                {/* <Button id="Ajouter" className={"btn-round btn btn-primary mr-2"}  onClick={() => {*/}
                {/*  setShowModal(true);*/}
                {/*  resetValues();*/}
                {/* }}>Ajouter un nouveau Colis</Button>{' '}*/}
                <div>
                  { showDisplayDateRange == 'none' ?
                            <Button
                              className={'btn-round'}
                              onClick={() => setDisplayDateRange('block')}
                            >
                                Choisir la date
                            </Button> :
                            <Button
                              className={'btn-round'}
                              onClick={() => setDisplayDateRange('none')}
                            >
                                Fermer le menu date
                            </Button>
                  }
                  <div id="dateRange-colis" style={{display: showDisplayDateRange, position: 'fixed'}} >
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => setState([item.selection])}
                      moveRangeOnFirstSelection={false}
                      ranges={state}
                      dateDisplayFormat="d MMM yyyy"
                      locale={fr}
                    />
                  </div>
                </div>


                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input type="text" className="form-control ml-5" placeholder="Rechercher"
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                      }}/>
                    <span className="input-group-btn btn btn-primary">
                      <span className=" fas fa-search"></span>
                    </span>
                  </div>
                </div>
              </div>
            </Card.Header>
            <Card.Body className="table-full-width table-responsive">
              <Table className="table-hover table-striped">
                <thead>
                  <tr>
                    <th className="border-0">Destinataire</th>
                    <th className="border-0">Heure</th>
                    <th className="border-0">Date</th>
                    <th className="border-0">Éxpéditeur</th>
                    <th className="border-0">Check-In</th>
                    <th className="border-0">Email</th>
                    <th className="border-0">Commentaire</th>
                  </tr>
                </thead>
                <tbody>
                  {content}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        className="modal modal-primary"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-backpack"></i>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">Ajouter un nouveau colis</p>
          <Form onSubmit={CreateParcel}>
            <Form.Group as={Row} controlId="formHorizontalDestinataire">
              <Form.Label column sm={4}>
           Destinataire :
              </Form.Label>
              <Col sm={8}>
                <Form.Control required type="Destinataire" placeholder="Destinataire" value={showRecipient} onChange={(e) => setRecipient(e.currentTarget.value)} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formHorizontalHour">
              <Form.Label column sm={4}>
            Heure :
              </Form.Label>
              <Col sm={8}>
                <Form.Control required type="time" value={showHour} onChange={(e) => setHour(e.currentTarget.value)}/>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formHorizontalDate">
              <Form.Label column sm={4}>
            Date :
              </Form.Label>
              <Col sm={8}>
                <Form.Control required type="date" value={showDate} onChange={(e) => setDate(e.currentTarget.value)} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formHorizontalName">
              <Form.Label column sm={4}>
            Éxpéditeur :
              </Form.Label>
              <Col sm={8}>
                <Form.Control required placeholder="Éxpéditeur" value={showSender} onChange={(e) => setSender(e.currentTarget.value)} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formHorizontalCompany">
              <Form.Label column sm={4}>
            Nom de l'entreprise :
              </Form.Label>
              <Col sm={8}>
                <Form.Control required placeholder="Nom de l'entreprise concernée" value={showCompany} onChange={(e) => setCompany(e.currentTarget.value)} />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Button
                className="btn-simple col-sm-6"
                type="button"
                variant="link"
                onClick={() => setShowModal(false)}
              >
              Fermer
              </Button>
              <Button className="btn-fill btn-round col-sm-6" type="submit">Créer </Button> {/* onSubmit={}*/}
            </Form.Group>

          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Colis;
